/**
 * @generated SignedSource<<7d4381122b7da51c5a57a4c67758f949>>
 * @relayHash ff452defe6c30c6aef6cb69359d0b5a9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useEditorContentModeValueQuery$variables = {
  contentId: string;
  isDraft: boolean;
  status?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type useEditorContentModeValueQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly contentProperties: {
        readonly draft?: {
          readonly contentMode: string | null | undefined;
        } | null | undefined;
        readonly latest?: {
          readonly contentMode: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly id: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useEditorContentModeValueQuery = {
  response: useEditorContentModeValueQuery$data;
  variables: useEditorContentModeValueQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isDraft"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "status"
  }
],
v1 = [
  {
    "kind": "ScalarField",
    "name": "contentMode"
  }
],
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "ContentProperties",
            "kind": "LinkedField",
            "name": "contentProperties",
            "plural": false,
            "selections": [
              {
                "condition": "isDraft",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "concreteType": "PublishedContentProperties",
                    "kind": "LinkedField",
                    "name": "latest",
                    "plural": false,
                    "selections": (v1/*: any*/)
                  }
                ]
              },
              {
                "condition": "isDraft",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "DraftContentProperties",
                    "kind": "LinkedField",
                    "name": "draft",
                    "plural": false,
                    "selections": (v1/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useEditorContentModeValueQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useEditorContentModeValueQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "ff452defe6c30c6aef6cb69359d0b5a9",
    "id": "34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad",
    "metadata": {},
    "name": "useEditorContentModeValueQuery",
    "operationKind": "query",
    "text": "query useEditorContentModeValueQuery($contentId:ID!,$isDraft:Boolean!,$status:[String]){content(id:$contentId,status:$status){nodes{id,contentProperties{latest@skip(if:$isDraft){contentMode},draft@include(if:$isDraft){contentMode}}}}}"
  }
};
})();

(node as any).hash = "51a479801516afe1b59a1bbcd1c3f7d5";

export default node;
